import Profile from '../Account/Profile'
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';

function ApprovalCheck() {
  const accessToken = localStorage.getItem("accessToken");
  const { token } = useSelector((state) => state.store);

  if (!accessToken && !token) {
    return <Navigate to={"/"} />;
  }

  return (
    <div>
      <Profile isBreadCrumb={false} />
    </div>
  )
}

export default ApprovalCheck